/**
 * @generated SignedSource<<ed19d48fd964027e480f8a6b40c77bc9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreatorsLetterSelector_creatorGroups$data = ReadonlyArray<{
  readonly groupName: string | null;
  readonly " $fragmentType": "CreatorsLetterSelector_creatorGroups";
}>;
export type CreatorsLetterSelector_creatorGroups$key = ReadonlyArray<{
  readonly " $data"?: CreatorsLetterSelector_creatorGroups$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreatorsLetterSelector_creatorGroups">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "CreatorsLetterSelector_creatorGroups",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "groupName",
      "storageKey": null
    }
  ],
  "type": "CreatorGroup",
  "abstractKey": null
};

(node as any).hash = "2dd943fb7c1efc1d3ed2dce5c147a9fb";

export default node;
